<template>
  <container v-bind="container">
    <draggable
      v-model="_value"
      draggable=".item"
      class="h-full flex items-center flex-wrap"
      @keydown.escape="handleClear()"
    >
      <div v-for="(item, index) in _value" :key="index" class="item py-1 pl-3 rounded-md bg-blue-100 text-blue-600 text-sm mr-1 my-px flex items-center transition cursor-move">
        {{ item }}

        <o-icon icon="x" :size="12" class="bg-blue-200 rounded-md h-5 w-5 flex items-center justify-center ml-3 mr-2 hover:bg-blue-300 transition cursor-pointer" @click="handleRemove(index)" />
      </div>

      <div
        slot="footer"
        key="footer"
        class="btn-group list-group-item flex-grow"
        role="group"
        aria-label="Basic example"
      >
        <input
          ref="input"
          v-model="inputValue"
          type="text"
          placeholder="Type and press enter to add items"
          class="w-full h-8 px-2 bg-transparent text-sm mt-px"
          @keydown.enter="handleAdd"
        >
      </div>
    </draggable>
  </container>
</template>

<script>
import draggable from 'vuedraggable'

import Container from './Container'

import classes from '@/mixins/fields/classes.js'
import input from '@/mixins/fields/input.js'

export default {
  components: {
    draggable,
    Container
  },
  mixins: [classes, input],
  props: {
    value: {
      type: Array,
      required: true
    },
    baseClass: {
      type: [String, Object, Array],
      default: 'h-auto w-full relative flex items-center'
    },
    defaultSizeClass: {
      type: String,
      default: 'p-2px'
    }
  },
  data () {
    return {
      inputValue: '',
      componentData: {
        props: {
          type: 'transition',
          name: 'flip-list'
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    handleAdd () {
      const inputValue = this.inputValue

      if (inputValue) {
        this._value.push(inputValue)
        this.inputValue = ''
        this.$nextTick(() => this.$refs.input.$el?.focus())
        this.$emit('change', this._value)
      }
    },
    handleClear () {
      this.inputValue = ''
    },
    handleRemove (index) {
      this._value.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

.sortable-ghost {
  opacity: 0.4;
  border: 1px dashed gray
}
</style>
